import http from 'plugins/axios';

export default {
  types() {
    return http.get({ url: '/ta/admin/tenant/msg/channel/types' });
  },
  page({ page, size, channelCode }) {
    let url = `/ta/admin/tenant/msg/channel/page?page=${page}&size=${size}`;
    if (channelCode) {
      url += `&channelCode=${encodeURIComponent(channelCode)}`;
    }
    return http.get({ url });
  },
  detail(id) {
    return http.get({ url: `/ta/admin/tenant/msg/channel/detail?id=${id}` });
  },
  save(data) {
    return http.post({ url: '/ta/admin/tenant/msg/channel/save', data });
  },
  update(data) {
    return http.post({ url: '/ta/admin/tenant/msg/channel/update', data });
  },
  remove(id) {
    return http.post({
      url: `/ta/admin/tenant/msg/channel/delete?id=${encodeURIComponent(id)}`,
    });
  },
};
